/* eslint-disable no-unused-vars, no-undef */
import queryString from 'query-string';
import Tracker from 'lib/tracker';
import { notifyErrors } from './logger';
import { logFirebaseEvent } from './firebaseHelper';

function getReferrer() {
  const params = queryString.parse(window.location.search);
  return params.from || '';
}

export function getReferrerUrl() {
  return document.referrer;
}

function getDefaultPageviewPayload(opts) {
  return {
    evn: 'pageviews',
    td_title: document.title,
    td_path: `${opts.base}${opts.to.path}`,
    td_url: `${opts.base}${opts.to.fullPath}`,
    td_viewport: `${document.documentElement.clientWidth}x${document.documentElement.clientHeight}`,
    td_referrer: opts.from?.meta?.page_url || document.referrer,
    td_host: window.location.hostname,
    referrer_url: getReferrerUrl(),
  };
}

function generatePayload(defaultPayload, params, opts) {
  let payload = {};
  if (params.evn === 'pageviews') {
    payload = { ...defaultPayload, ...getDefaultPageviewPayload(opts) };
  } else {
    payload = { ...defaultPayload, ...params };
  }
  return payload;
}

export function buildTrackerPayload(params, options) {
  const defaultOptions = { withReferrer: true };
  const opts = { ...defaultOptions, ...options };
  const ui =
    (global.USER && global.USER.id36) || (global.blGlobal && global.blGlobal.user && global.blGlobal.user.id_36) || '';

  const defaultPayload = {
    t: new Date().getTime(),
    ui,
  };

  if (opts.withReferrer) defaultPayload.referrer = getReferrer();

  return generatePayload(defaultPayload, params, opts);
}

/* istanbul ignore next */
export function trackEvent(params, options) {
  const payload = buildTrackerPayload(params, options);
  Tracker.event(payload).catch(e => {
    notifyErrors('SMAUG_TRACKER', e, payload);
  });

  const { evn, ...firebasePayload } = payload;
  logFirebaseEvent(evn, firebasePayload);
}

export default {
  trackEvent,
  getReferrerUrl,
};
